import { Injectable } from '@angular/core';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    constructor(private spinner: NgxSpinnerService) {}

    public show(spinnerName: string) {
        this.spinner.show(spinnerName);
    }

    public hide(spinnerName: string) {
        this.spinner.hide(spinnerName);
    }

    public getSpinner(spinnerName: string): Observable<NgxSpinner> {
        return this.spinner.getSpinner(spinnerName);
    }
}
